import template from './AreaParts.jade';

export const AreaParts = () => {
  return {
    template,
    scope: {},
    bindToController: {},
    controller: ['$scope', 'deviceService', function($scope, deviceService) {
      $scope.isMobile = deviceService.isMobile;
    }],
    controllerAs: 'AreaPartsCtrl',
    replace: true,
  };
};
